module.exports = __webpack_public_path__ + "static/media/tenis-vermelho.bca87c97.jpg";